import { AnimatedTitleHeroProps } from '@/components/_rebrand/AnimatedTitleHero';
import { MediaSectionProps } from '@/components/_rebrand/MediaSection';
import { PageBumperProps as PageBumperPropsType } from '@/components/_rebrand/PageBumper';
import { RelatedContentCarouselProps } from '@/components/_rebrand/RelatedContentCarousel';
import { WhatsNewCtaProps } from '@/components/_rebrand/WhatsNewCta';

export const HeroProps = {
  eyebrow: 'Interview Series',
  titleSVG: {
    src: 'https://front.com/assets/pages/landing-pages/untangled-ops.svg',
    alt: 'Untangled Ops',
  },
  description:
    "Snake is child's play compared to these leaders solving complex operational problems. Watch them crush both.",
} as const satisfies AnimatedTitleHeroProps;


export const MainVideoProps = {
  title: 'Episode 06 - Buğra Gündüz, CEO & Co-founder, HockeyStack',
  description:
    'HockeyStack trained an AI agent to have their CTO’s judgment, going from 40% to over 80% accuracy. Hear Buğra explain how they pulled it off.',
  videoId: '9LRixiiQ-5I',
  thumbnailSrc:
    'https://front.com/assets/pages/landing-pages/untangled-ops-episode-6-hero.png',
  thumbnailAlt: 'Watch the Untangled Ops episode 06 video',
} as const satisfies MediaSectionProps;

export const SeriesCarouselProps: Pick<RelatedContentCarouselProps, 'title' | 'items'> = {
  title: 'Catch up on the series',
  items: [
    {
      category: 'Blog',
      title: 'Read Episode 06 recap',
      imageSrc: 'https://front.com/assets/pages/landing-pages/untangled-ops-episode-6-thumbnail.png',
      href: '/blog/untangled-ops-episode-6',
    },
    {
      category: 'Video',
      title: 'Watch episode 05: Nikola Mrkšić, CEO, PolyAI',
      imageSrc:
        'https://front.com/assets/pages/landing-pages/untangled-ops-episode-5-hero-thumbnail.png',
      videoId: 'jq5djL6QKXY',
    },
    {
      category: 'Blog',
      title: 'Read Episode 05 recap',
      imageSrc: 'https://front.com/assets/pages/landing-pages/untangled-ops-episode-5-recap.png',
      href: '/blog/untangled-ops-episode-5',
    },
    {
      category: 'Video',
      title: 'Watch episode 04: Aarde Cosseboom, CEO & Founder, Palomarr',
      imageSrc:
        'https://front.com/assets/pages/landing-pages/untangled-ops-episode-4-upadted-thumbnail.png',
      videoId: '4KYlbHvTfBY',
    },
    {
      category: 'Blog',
      title: 'Read Episode 04 recap',
      imageSrc: 'https://front.com/assets/pages/landing-pages/untangled-ops-episode-4-recap.png',
      href: '/blog/untangled-ops-episode-4',
    },
    {
      category: 'Video',
      title: 'Watch episode 03: Grace Gong, CEO & Founder, Smart Venture Media',
      imageSrc: 'https://front.com/assets/pages/landing-pages/untangled-ops-episode-3-hero.png',
      videoId: 'TVeF4ACTEsk',
    },
    {
      category: 'Blog',
      title: 'Read Episode 03 recap',
      imageSrc: 'https://front.com/assets/pages/landing-pages/untangled-ops-episode-3-recap.png',
      href: '/blog/untangled-ops-episode-3',
    },
    {
      category: 'Video',
      title: 'Watch episode 02: Ben Graeff, COO, FreightPlus',
      imageSrc:
        'https://front.com/assets/pages/landing-pages/untangled-ops-ben-freightplus-new.png',
      videoId: 'Cm_8G3pPrAM',
    },
    {
      category: 'Blog',
      title: 'Read Episode 02 recap',
      imageSrc: 'https://front.com/assets/pages/landing-pages/episode-2-recap-new.png',
      href: '/blog/untangled-ops-episode-2-show-notes',
    },
    {
      category: 'Video',
      title: 'Watch episode 01: Oleg Krasnov, Head of CX, Manychat',
      imageSrc: 'https://front.com/assets/pages/landing-pages/untangled-ops-ep1-preview-16-9-aspect-ratio.png',
      videoId: 'Gn5M7fAfONI',
    },
    {
      category: 'Blog',
      title: 'Read Episode 01 recap',
      imageSrc: 'https://front.com/assets/pages/landing-pages/episode-1-recap-new.png',
      href: '/blog/untangled-ops-episode1',
    },
  ],
};

export const CoordinationTaxCtaProps = {
  eyebrow: "What's New",
  title: 'Read Front’s new research report',
  mobileImageSrc: 'https://front.com/webassets/rebrand/whats-new-cta-coordination-tax-mobile.svg',
  desktopImageSrc: 'https://front.com/webassets/rebrand/whats-new-cta-coordination-tax-desktop.svg',
  button: {
    text: 'Learn more',
    action: 'url',
    href: '/resources/coordination-tax-report',
  },
} as const satisfies WhatsNewCtaProps;

export const PageBumperProps = {
  title: 'Ready to lower your coordination tax? Try Front.',
  links: [
    {
      type: 'primary',
      title: 'Book a demo',
      href: '',
      action: 'demo',
    },
    {
      type: 'secondary',
      title: 'Try for free',
      href: '',
      action: 'trial',
    },
  ],
  backgroundColor: 'bg-white',
  staticImage: null,
} as const satisfies PageBumperPropsType;
